import React from 'react';
import { useSelector } from 'react-redux';
import { Grid, Stack } from '@esgian/esgianui';
import { useMainPageQueries } from '@hooks/usePageQueries/useMainPageQueries';
import { getMainPageSlice } from '@store/features/filters/MainPageSlice/MainPageSlice';
import { getRigSlice } from '@store/features/filters/RigSlice/RigSlice';
import { TotalForPeriodChartJS, TotRegeneratedEnergyDrawworks } from '@components/SubSections/Equipment';
import { PeriodicOverviewDetails } from '@components';

function EquipmentSection() {
  const { rigEquipmentQuery, rigEquipmentSignalsQuery, rigEquipmentConfigQuery } = useMainPageQueries();
  
  const { selectedRig } = useSelector(getMainPageSlice);
  const rigStateSettings = useSelector(state => getRigSlice(state, selectedRig.rigName));
  const isEquipmentSelected = rigStateSettings?.isEquipmentSelected;
  const selectedEquipmentName = rigStateSettings?.selectedEquipmentName;

  return (
    <Grid container spacing={2}>
      <Grid item xs={3.5}>
        <Stack spacing={2}>
          <TotalForPeriodChartJS
            equipmentData={rigEquipmentQuery.data}
            loading={rigEquipmentQuery.isFetching}
            equipmentSignalsData={rigEquipmentSignalsQuery.data}
            equipmentConfig={rigEquipmentConfigQuery.data}
          />
          {(!isEquipmentSelected || selectedEquipmentName.toLowerCase() === 'drawworks') && 
            <TotRegeneratedEnergyDrawworks
              equipmentData={rigEquipmentQuery.data}
              loading={rigEquipmentQuery.isFetching}
            />
          }
        </Stack>
      </Grid>
      <Grid item xs={8.5}>
        <PeriodicOverviewDetails
          equipmentData={rigEquipmentQuery.data}
          loading={rigEquipmentQuery.isFetching}
          equipmentConfig={rigEquipmentConfigQuery.data}
          equipmentSignalsData={rigEquipmentSignalsQuery.data}
          equipmentSignalsLoading={rigEquipmentSignalsQuery.isFetching}
        />
      </Grid>
    </Grid>
  );
}

EquipmentSection.propTypes = {};

EquipmentSection.defaultProps = {};

export default EquipmentSection;
